import { render, staticRenderFns } from "./qualificationTypeSelection.vue?vue&type=template&id=5da671a0&"
import script from "./qualificationTypeSelection.vue?vue&type=script&lang=js&"
export * from "./qualificationTypeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports